// extracted by mini-css-extract-plugin
export default {"title":"MeliProfile_title__xzlID","submit":"MeliProfile_submit__iETl6"};